module.exports = __webpack_public_path__ + "img/user-illustarator-2.d365a2dc.png";